import { LinksGroupWire, LinkWire } from 'app/area/links-section/types';
import { Link, LinksGroup } from 'app/area/links-section/types-store';

export const mapToStore = (linksGroupsWire: LinksGroupWire[]): LinksGroup[] => linksGroupsWire?.map(linksGroupWire => ({
  description: linksGroupWire.description,
  longDescription: linksGroupWire.longDescription,
  links: mapLinksToStore(linksGroupWire.externalUrls)
}));

const mapLinksToStore = (linksWire: LinkWire[]): Link[] => linksWire?.map(linkWire => ({
  description: linkWire.description,
  longDescription: linkWire.longDescription,
  url: linkWire.urlTemplate
}));
